const ITEMS = [
    "Pregătirea casei",
    "Transport coordonat",
    "Mese & gospodărie",
    "Vizite & conversație",
    "Îngrijirea animalelor",
    "Însoțire la programări",
    "Familia informată",
    "Primele zile organizate",
];

export const Marquee = () => (
    <div className="overflow-hidden border-y border-teal/10 bg-sand/60 py-5" data-testid="marquee-strip" aria-hidden="true">
        <div className="marquee-track animate-marquee flex w-max items-center">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex items-center">
                    {ITEMS.map((item) => (
                        <span key={`${copy}-${item}`} className="flex items-center">
                            <span className="whitespace-nowrap px-8 font-serif text-xl sm:text-2xl italic text-teal/70">{item}</span>
                            <span className="h-1.5 w-1.5 rounded-full bg-coral/70" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
